// Copyright (c) 2019 Deere & Company

import actions from '../actions-list';

const includeFullyComplete = (state, action) => action.includeFullyComplete;

export default (state = false, action) => {

    const actionTypes = {
        [actions.UPDATE_OPEN_PIP_PROGRAMS_REPORT_INCLUDE_FULLY_COMPLETE]: includeFullyComplete
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/reducers/include-fully-complete.js